<template>
  <section class="homepage-section">
    <TwinColorTitle> Explore the world <br /><em>your way</em> </TwinColorTitle>

    <ListTrips apiPath="/en/home.json" continents />
  </section>
</template>

<script setup>
import TwinColorTitle from '@/components/Theme2/TwinColorTitle.vue'
import ListTrips from '@/components/ListTrips.vue'
</script>

<style lang="scss" scoped>
section.homepage-section {
  @include main-rewrap;

  gap: 32px;
  padding-block: 64px;
  align-items: center;
  border-radius: 16px;
  background: url('app/assets/images/common/color-bg.jpg') lightgray 50% / cover no-repeat;

  @include mobile {
    gap: 24px;
    padding-inline: 0;
    padding-block: 32px;
  }
}
</style>
